import axios from 'axios'
import punchlistAxios from '../punchlist/axios'
import { ApiController } from './types'

const apiController: ApiController = {
  uploadFile: async (signedURL: string, file: File) =>
    await axios
      .put(signedURL, file, {
        headers: {
          'Content-Type': file.type
        }
      })
      .then(response => response),
  downloadFile: async (documentType: string, resourceId: string, parameters: any) =>
    await punchlistAxios.post(`/documents/pdf`, {
      documentType,
      resourceId,
      parameters
    })
      .then(response => response),
  getPDF: async (reportId: string) =>
    await punchlistAxios.get(`/documents/pdf/${reportId}`)
      .then(response => response)
}

export default apiController
